const CLINICAL_REPORT_ANONYMIZATION_ENABLED_STORAGE_KEY = "clinicalReportAnonymizationEnabled";

export const getStoredClinicalReportAnonymizationEnabled = () => {
    const storedAnonymizationEnabled = window.localStorage.getItem(CLINICAL_REPORT_ANONYMIZATION_ENABLED_STORAGE_KEY);
    if (storedAnonymizationEnabled === null) {
        return null;
    }
    return storedAnonymizationEnabled !== "false";
};

export const isClinicalReportAnonymizationEnabled = (
    isGlobalAnonymizationEnabled,
    storedAnonymizationEnabled = getStoredClinicalReportAnonymizationEnabled()
) => storedAnonymizationEnabled ?? (isGlobalAnonymizationEnabled !== false);

export const saveClinicalReportAnonymizationEnabled = (isAnonymizationEnabled) => {
    window.localStorage.setItem(CLINICAL_REPORT_ANONYMIZATION_ENABLED_STORAGE_KEY, String(isAnonymizationEnabled));
};
